// Shared design tokens for the Join-a-Walk screen (brand: navy + gold, from the logo).
export const NAVY = "#FFFFFF";            // primary text / background
export const BRAND = "#ff4d6d";          // gold accent
export const BRAND_LIGHT = "#ff4d6d";
export const BRAND_GRADIENT = `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_LIGHT} 100%)`;
export const CARD_RADIUS = 16;
